import { PromoModalType } from "@faire/web-api--source/indigofair/data/PromoModalType";
import { route as paymentMethodsRoute } from "@faire/web-api--source/routes/www/retailer/settings/payment-methods";
import { route as unpaidInvoicesRoute } from "@faire/web-api--source/routes/www/user/account/invoices/unpaid";
import { getWindowOrThrow } from "@faire/web/common/globals/getWindow";
import { matchPath } from "react-router-dom";

import { IGateHook } from "./type";
import { useModalType } from "./useModalType";

export const usePastDueInvoiceGate: IGateHook = () => {
  const modalType = useModalType();

  if (
    !OVERDUE_INVOICES_BLOCKED_PATHS.some(
      (path) =>
        !!matchPath(getWindowOrThrow().location.pathname, { path, exact: true })
    ) &&
    modalType === PromoModalType.PAST_DUE_INVOICE_MODAL
  ) {
    return PromoModalType.PAST_DUE_INVOICE_MODAL;
  }

  return undefined;
};

const OVERDUE_INVOICES_BLOCKED_PATHS = [
  paymentMethodsRoute,
  unpaidInvoicesRoute,
];
